import React from 'react'
import { useStyles } from './styles'
import { GenderMaleIcon, GenderFemaleIcon, TicketIcon } from 'src/assets/svg'
import { formatDate } from 'src/utils'
import DeleteOutline from '@material-ui/icons/DeleteOutline'

type SavedAnimalProps = {
  savedBirthAnimal: any
  index: number
  onRemove?: () => void
}
export const SavedAnimal: React.FC<SavedAnimalProps> = ({ savedBirthAnimal, index, onRemove }) => {
  const style = useStyles()
  const isMale = savedBirthAnimal.sexo === 'M'

  return (
    <div className={style.savedBirthCard}>
      <div className={style.cardHeader}>
        <span className={style.birthBadge}>Nascimento {index + 1}</span>
        <div className={style.cardHeaderActions}>
          <span className={style.genderIcon}>{isMale ? <GenderMaleIcon /> : <GenderFemaleIcon />}</span>
          {onRemove && (
            <button type='button' onClick={onRemove} className={style.removeButton} title='Remover animal'>
              <DeleteOutline />
            </button>
          )}
        </div>
      </div>

      <div className={style.cardRow}>
        <span className={style.animalName}>{savedBirthAnimal.nome || 'Animal sem nome'}</span>
      </div>

      <div className={style.cardRow}>
        <TicketIcon className={style.icon} />
        <span className={style.infoText}>{savedBirthAnimal.cdn || ''}</span>
      </div>

      {savedBirthAnimal.dataNascimento && (
        <div className={style.cardRow}>
          <span className={style.infoLabel}>Data:</span>
          <span className={style.infoText}>{formatDate(savedBirthAnimal.dataNascimento, false) || '-'}</span>
        </div>
      )}

      {savedBirthAnimal.pesoAoNascer && (
        <div className={style.cardRow}>
          <span className={style.infoLabel}>Peso:</span>
          <span className={style.infoText}>{savedBirthAnimal.pesoAoNascer} kg</span>
        </div>
      )}
    </div>
  )
}
